import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29ef91b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "test-questions" }
const _hoisted_2 = {
  class: "test-scroll__header",
  id: "js-test-scroll"
}
const _hoisted_3 = { class: "img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "test-scroll__body" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "test-text__list" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["src"]

import { ref, inject, toRefs } from "vue"
import ScrollArea from '../parts/ScrollArea.vue'
import { examKey } from "@/main";
import { Page } from "@/store/exam";

interface Props {
  question: Page
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Layout5',
  props: {
    question: null
  },
  setup(__props: any) {

const props = __props as {
  question: Page
};

const exam = inject(examKey);



const { question } = toRefs(props);

const image = ref<string>();
const scrollArea = ref();
const hideArrow = ref<boolean>(false);

const init = async () => {
  if (!question.value.image) return;
  const questions = await exam?.questions();
  image.value = questions?.images[question.value.image];
}
init();

const updateBar = (isEnd: boolean) => {
  hideArrow.value = isEnd;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "test-scroll",
        ref_key: "scrollArea",
        ref: scrollArea
      }, [
        (scrollArea.value != null)
          ? (_openBlock(), _createBlock(ScrollArea, {
              el: scrollArea.value,
              key: _unref(question).pageNumber,
              onUpdate: updateBar
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    (image.value)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: image.value,
                          alt: "",
                          id: "img"
                        }, null, 8, _hoisted_4))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("p", {
                      innerHTML: _unref(question).questions[0].questionText
                    }, null, 8, _hoisted_6),
                    _createElementVNode("ol", _hoisted_7, [
                      _createElementVNode("li", {
                        innerHTML: _unref(question).questions[0].choices[0].text
                      }, null, 8, _hoisted_8),
                      _createElementVNode("li", {
                        innerHTML: _unref(question).questions[0].choices[1].text
                      }, null, 8, _hoisted_9),
                      _createElementVNode("li", {
                        innerHTML: _unref(question).questions[0].choices[2].text
                      }, null, 8, _hoisted_10)
                    ]),
                    (_unref(question).example)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: "test-hint",
                          innerHTML: _unref(question).questions[0].explanation
                        }, null, 8, _hoisted_11))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("img", {
                  src: require('@/assets/img/arrow-down.svg'),
                  alt: "",
                  class: _normalizeClass(["test-icon-scroll", {'is-hide': hideArrow.value}])
                }, null, 10, _hoisted_12)
              ]),
              _: 1
            }, 8, ["el"]))
          : _createCommentVNode("", true)
      ], 512)
    ])
  ]))
}
}

})